import { AxiosError } from 'axios';
import { QueryError } from 'shared/components/Notification/types';

export const formatErrorMessage = ({
  code,
  message,
}: AxiosError | QueryError): string => `${code ? `${code}: ` : ''}${message}`;
